import(/* webpackMode: "eager" */ "/vercel/path0/app/press-kit/page.tsx")